module.exports = __webpack_public_path__ + "static/media/menu_logo_bsa.fdcdb45d.png";